module.exports = __webpack_public_path__ + "cx.svg?43581198b1275d9f2b80393a89140292";